import React from 'react';
import { Edit, SimpleForm } from 'react-admin';
import { FormPageTitle, FormToolbar } from '@/components/shell';
import { ServerFields } from './ServerFields';

const BACK_TO = '/system?tab=servers';

export const ServerEdit = () => (
  <Edit mutationMode="pessimistic" actions={<FormPageTitle mode="edit" />}>
    <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} showDelete />}>
      <ServerFields mode="edit" />
    </SimpleForm>
  </Edit>
);
